"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProposalStatus = void 0;
// This is not the type for result of query.
var ProposalStatus;
(function (ProposalStatus) {
    ProposalStatus[ProposalStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ProposalStatus[ProposalStatus["DEPOSIT_PERIOD"] = 1] = "DEPOSIT_PERIOD";
    ProposalStatus[ProposalStatus["VOTING_PERIOD"] = 2] = "VOTING_PERIOD";
    ProposalStatus[ProposalStatus["PASSED"] = 3] = "PASSED";
    ProposalStatus[ProposalStatus["REJECTED"] = 4] = "REJECTED";
    ProposalStatus[ProposalStatus["FAILED"] = 5] = "FAILED";
})(ProposalStatus = exports.ProposalStatus || (exports.ProposalStatus = {}));
//# sourceMappingURL=types.js.map